import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import { useParams } from 'react-router-dom'
import { Alert, Button, Col, Container, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import Select from 'react-select'
import PageHeader from '../../components/pageHeader/pageHeader.component';
import BlogCard from '../../components/blogCard/blogCard.component';
import BlogStickyCard from '../../components/blogCard/blogStickyCard.component';
import { FaSearch } from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";

import BlogsPageCover from '../../assets/images/banners/blogs-banner.png';

import './blogsPage.module.css';

const Blogs = props => {
    const formRef= useRef();
    const { loading, blog, blogCategories } = useSelector(state => state.all)

    const [allBlogs, setAllBlogs] = useState([])
    const [stickyItem, setStickyItem] = useState([])

    const [selectedTag, setSelectedTag] = useState(null)

    const [search, setSearch] = useState(null)
    const [showSearchReset, setShowSearchReset] = useState(false)

    useEffect(() => {
        setAllBlogs(blog.filter(item => !('sticky' in item) || !item.sticky))
        setStickyItem(blog.filter(item => ('sticky' in item) && item.sticky))
    }, [blog])

    const handleFilter = i => {
        setSelectedTag(i)
        if(!!i) {
            setAllBlogs(blog.filter(item => (item.category === i) && (!('sticky' in item) || !item.sticky)))
        } else {
            setAllBlogs(blog.filter(item => !('sticky' in item) || !item.sticky))
        }
    }

    const changeSearch = i => {
        setSearch(i)
        setShowSearchReset(false)
    }

    const handleSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSearch(search)
        if(!!search) {
            setShowSearchReset(true)
        } else {
            setShowSearchReset(false)
        }
        setAllBlogs(blog.filter(item => item.title.includes(search)))
    }

    const resetSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSearch(null);
        formRef.current.reset();
        setAllBlogs(blog);
        setShowSearchReset(false)
    }

    console.log('search', search);

    return (
        <div>
            <PageHeader title="ব্লগ" />

            <section className="blog-tags-section py-4 py-md-3 border-top border-bottom" styleName="blog-tags-section">
                <Container>
                    {
                        loading ? <Loading /> :
                        <Row>
                            <Col xs={12} md={4} className="mb-3 mb-md-0">
                                <Select
                                    placeholder="Select Category"
                                    defaultValue={null}
                                    onChange={(selected) => handleFilter(!!selected ? selected.value : null)}
                                    isClearable={true}
                                    isSearchable={false}
                                    blurInputOnSelect={true}
                                    options={!!blogCategories && blogCategories.map((str, index) => ({ value: str, label: str }))}
                                    unstyled
                                />
                            </Col>
                            <Col xs={12} md={{ span: 4, offset: 4 }}>
                                <div className="ml-auto" styleName="blog-search-wrap">
                                    <Form onSubmit={handleSearch} ref={formRef}>
                                        <InputGroup className="mb-0">
                                            <FormControl
                                                type='search'
                                                onChange={(e) => changeSearch(e.target.value)}
                                                placeholder="ক্যাটাগরি অথবা টাইটেল দিয়ে সার্চ করুন..."
                                                aria-label="ক্যাটাগরি অথবা টাইটেল দিয়ে সার্চ করুন..."
                                            />
                                            {
                                                showSearchReset ?
                                                <Button onClick={resetSearch} type="submit" variant="outline-secondary" styleName="search-btn">
                                                    <AiFillCloseCircle />
                                                </Button>
                                                : <Button onClick={handleSearch} type="submit" variant="outline-secondary" styleName="search-btn">
                                                    <FaSearch />
                                                </Button>
                                            }
                                        </InputGroup>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    }
                </Container>
            </section>
            <section className="blog-section section py-5 border-top mb-5">
                <Container>
                    {loading ? <Loading /> : (
                        <Row>
                            {stickyItem.length > 0 && stickyItem.map((item, index) => {
                                if (index < 1) {
                                    return <Col xs={12} md={12} className="mb-5">
                                        <BlogStickyCard
                                            url={`/blog/${item.title.replace(/ /g, "-")}/${item._id}`}
                                            banner={`${bucket_url}${item.coverPhoto}`}
                                            title={item.title}
                                            subTitle={item.excerpt}
                                            createdAt={item.createdAt}
                                        />
                                    </Col>
                                }
                                return null
                            })}
                            {allBlogs && allBlogs.map(item => {
                                if (item.status === 'show') {
                                    return <Col xs={12} md={4} className="mb-5">
                                        <BlogCard
                                            url={`/blog/${item.title.replace(/ /g, "-")}/${item._id}`}
                                            banner={`${bucket_url}${item.coverPhoto}`}
                                            title={item.title}
                                            subTitle={item.excerpt}
                                            createdAt={item.createdAt}
                                        />
                                    </Col>
                                }
                                return null
                            })}
                            {
                                allBlogs && (allBlogs.length === 0) &&
                                <Col xs={12} className="mb-5">
                                    <Alert variant="warning" className="text-center">
                                        দুঃখিত, কোন আর্টিকেল খুজে পাওয়া যায় নি।
                                    </Alert>
                                </Col>
                            }
                        </Row>
                    )}
                </Container>
            </section>
        </div>
    )
}

export default Blogs;